import { Controller } from "@hotwired/stimulus"

const MIN_SECONDS = 0
const MAX_SECONDS = 59
const NON_NUMERIC_KEYS = ["e", "E", "+", "."]

export default class extends Controller {
  static targets = ["minutes", "seconds", "hidden"]

  connect() {
    this.syncInputsFromHidden()
  }

  preventNonNumeric(event) {
    if (NON_NUMERIC_KEYS.includes(event.key)) event.preventDefault()
  }

  updateHidden() {
    if (this.minutesTarget.value === "" && this.secondsTarget.value === "") {
      this.hiddenTarget.value = ""
      return
    }

    this.clampSeconds()
    const minutes = parseInt(this.minutesTarget.value) || 0
    const seconds = parseInt(this.secondsTarget.value) || 0
    const sign = minutes < 0 ? -1 : 1
    this.hiddenTarget.value = minutes + sign * seconds / 60.0
  }

  clampSeconds() {
    const seconds = parseInt(this.secondsTarget.value)
    if (isNaN(seconds)) return

    if (seconds > MAX_SECONDS) {
      this.secondsTarget.value = MAX_SECONDS
    } else if (seconds < MIN_SECONDS) {
      this.secondsTarget.value = MIN_SECONDS
    }
  }

  syncInputsFromHidden() {
    const totalMinutes = parseFloat(this.hiddenTarget.value) || 0
    const isNegative = totalMinutes < 0
    const absoluteSeconds = Math.abs(Math.round(totalMinutes * 60))
    this.minutesTarget.value = isNegative ? -Math.floor(absoluteSeconds / 60) : Math.floor(absoluteSeconds / 60)
    this.secondsTarget.value = absoluteSeconds % 60
  }
}
